module.exports = __webpack_public_path__ + "img/osf-icon@3x.383f9b9f.png";